import { goto } from '../../src/actions/historyActions';
import { LinkPayload } from '../../src/types/prismicTypes';

const AXA_DOMAIN_REGEX = /^https:\/\/www\.[\w-]{0,}axa\.com\.hk.*/g;

export const isCorpApp = (link: string) => {
  return AXA_DOMAIN_REGEX.test(link);
};

const handleEmmaDeeplink = (
  fullLink: string,
  lang: string,
  bannerPrismicId: string,
) => {
  const parsedUrl = new URL(fullLink);
  const url = parsedUrl.searchParams.get('url');
  url.replace('${language}', lang);
  const query = new URLSearchParams(decodeURIComponent(parsedUrl.search));
  query.delete('url');

  if (url.match(/(emma-banner-routing)/)) {
    bannerPrismicId && query.append('bannerPrismicId', bannerPrismicId);
  }

  const deeplink = query.size > 0 ? `${url}?${query.toString()}` : url;

  if (deeplink) {
    goto(deeplink);
    return;
  }
  console.warn(`deeplink is empty for ${fullLink}`);
};

const addParamsForCorpWeb = (link: string) => {
  const newUrl = new URL(link);
  if (!newUrl.searchParams.get('platform')) {
    newUrl.searchParams.append('platform', 'emmaportal');
  }
  return newUrl.toString();
};

const handleExternalLink = (link: string, inNewTab: boolean) => {
  const newLink = isCorpApp(link) ? addParamsForCorpWeb(link) : link;

  if (inNewTab) {
    window.open(newLink, '_blank');
  } else {
    window.location.href = newLink;
  }
};

export const openPrismicLink = (
  linkObj: LinkPayload,
  linkQueue: string,
  linkType: string,
  lang: string,
  prismicBannerId: string,
) => {
  const { link, document } = linkObj;
  if (!link) {
    return;
  }

  if (link && link.match(/^(https:\/\/)/)) {
    if (link.match(/^(https:\/\/emma-deeplink)/)) {
      handleEmmaDeeplink(link, lang, prismicBannerId);
      return;
    } else {
      handleExternalLink(link, linkObj.inNewTab);
      return;
    }
  } else if (document && link) {
    goto(`emma-cms?path=${link}`);
    return;
  }

  return;
};
